import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FormTooltipComponent } from '@shared/components/form-tooltip/form-tooltip.component';
import { CapturumCheckboxComponent } from '@capturum/ui/checkbox';
import { ManageValidatorDisplayDirective } from '@features/client/form-builder/directives/hide-validator.directive';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-checkbox-list-input',
  templateUrl: './checkbox-list-input.component.html',
  imports: [FormTooltipComponent, CapturumCheckboxComponent, ManageValidatorDisplayDirective, AsyncPipe],
})
export class CheckboxListInputComponent extends FieldType {
  public setChecked(option: any, checked: boolean): void {
    let controlValue = this.formControl.value;
    const optionValue = option[this.props.value_key];

    if (checked) {
      if (Array.isArray(controlValue)) {
        controlValue.push(optionValue);
      } else {
        controlValue = [optionValue];
      }
    } else {
      controlValue = controlValue.filter((item) => {
        return item !== optionValue;
      });
    }

    this.formControl.setValue(controlValue);
  }
}
